import { Country, User } from '@spartacus/core';
import { UserRegisterFacade, UserSignUp } from '@spartacus/user/profile/root';
import { Observable } from 'rxjs';
import { DocumentIdentifierType, JobType, UserTaxGroup } from 'src/app/spartacus/spartacus-custom.module';

export abstract class CustomUserRegisterFacade extends UserRegisterFacade {
  abstract getCountries(): Observable<Country[]>;

  abstract getJobTypes(): Observable<JobType[]>;

  abstract getDocumentIdentifierTypes(): Observable<DocumentIdentifierType[]>;

  abstract loadJobTypes(): void;

  abstract getUserTaxGroups(): Observable<UserTaxGroup[]>;
  abstract loadUserTaxGroups(): void;
  abstract loadDocumentIdentifierTypes(): void;
  abstract documentIdentifierValidator(user: UserSignUp): Observable<User>;
  // abstract documentIdentifierValidator(user: UserSignUp): void;
}
